// --------------------------  Size-charts  ------------------------
function sizeChartsFunc(){
let mainC = $('#MainContent:has(.size-charts)');
if(mainC.length > 0){
// Brands section = .container
let brandContainer = $('.container')
let brandShow
const allBrands = []
const aToC = ['A', 'B', 'C']
const dToP = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P']
const qtoZ = ['Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
// Brand Select Dropdown
$(document).ready(function () {
    brandContainer.each(function () {
        brandShow = $(this).attr('id')
        const brand = $(this).attr('data-brand');
        allBrands.push(brand)
    })
    allBrands.sort();
    allBrands.forEach(function (brand){
        if (aToC.includes(brand.charAt(0))) {
            $('.brand-container > .first-brands').append(`<p class="${brand}">${brand}</p>`);
        } else if (dToP.includes(brand.charAt(0))) {
            $('.brand-container > .second-brands').append(`<p class="${brand}">${brand}</p>`);
        } else if (qtoZ.includes(brand.charAt(0))) {
            $('.brand-container > .third-brands').append(`<p class="${brand}">${brand}</p>`)
        }
    })
    $('#brand-select').click(function (e) {
        e.stopPropagation();
        $('.brand-container').toggleClass('visible');
    });
    let brandsContainer = document.querySelector('.brand-container');
    document.body.addEventListener('click', function (e) {
        if (!brandsContainer.contains(e.target) && !$(e.target).is('#brand-select')) {
            brandsContainer.classList.remove('visible')
        }
    })

    // let brandContainerAttr = brandContainer.attr('id')
    $('.brand-container > div > p').click(function (e) {

        $('.brand-container').removeClass('visible')
        let selectedValue = $(this).text().replace(/\s/g, "");
        // console.log(selectedValue, ' SV')
        const capitalize = s => s && s[0].toUpperCase() + s.slice(1).toLowerCase()
        let selectedValuePro = capitalize(selectedValue)
        // console.log(capitalize(selectedValue), ' CAP')
        $('#brand-select > p').text(selectedValue)
        // $('#brand-select > p').attr('id', selectedValue)
        // ------------      To show Nav bar when a brand is clicked    -----------
        // if ($('#brand-select > p').text() === 'All') {
        //     brandContainer.show();
        //     $('.navbar').hide();
        //     console.log($('.container > div'), ' %%%')
        // } else {
        // -------------- Show Specific brand -----------------
        brandContainer.hide();
        $('#' + $.escapeSelector(selectedValuePro)).show(); //In jQuery, $('#' + selectedValue) selects an element by its ID using the # symbol followed by the ID value.
        $('.navbar').show().css('display', 'flex')
        $('.navbar > .subnav:nth-of-type(1)').addClass('sub-active').siblings().removeClass('sub-active')
        // console.log('selected ', selectedValue)
        // }

        // ----------- Selects the first gender and displays it's tables -----------
        $('div[data-gender]').each(function () {
            let containerGender = $(this).attr('data-gender')
            let subnavText = $('.subnav:first-of-type').children('.subnavbtn').text().replace(/'/g, "").toLowerCase();

            if (subnavText === containerGender) {
                console.log('Match found:', subnavText, '===', containerGender);
                $(this).show();
            } else if (selectedValue === 'All') {
                // console.log($(this), ' THJ')
                $(this).show(); // For all select functionality
            } else {
                $(this).hide();
            }
        })
        $('.subnav-content').empty();
        let subNavText = $('.subnav:first-of-type').children('.subnavbtn').text().replace(/'/g, "").toLowerCase();
        let containerGender = $('div[data-gender]').attr('data-gender');


        // -------------- Displays the initial category types of the gender ------------------
        if (subNavText === containerGender) {
            let typesArray = [];
            let containers = document.querySelectorAll('div[data-gender]');
            containers.forEach(function (container) {
                let containerGender = container.getAttribute('data-gender');

                if (containerGender === subNavText) {
                    let types = container.getAttribute('data-id')
                    typesArray.push(types);
                }
            });

            let uniqArray = typesArray.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });

            uniqArray.forEach(uniqItem => {
                $('.subnav-content').append('<span href="">' + uniqItem + '</span>');
                $('.subnav-content').children().first().addClass('category-active')
            });


            // To display Particular category tables only on load
            let activeElementWithClass = $('.category-active').text()
            $('div[data-gender]').each(function () {
                console.log($(this).attr('id'))
                if ($(this).attr('data-gender') === subNavText) {
                    if ($(this).attr('data-id') === activeElementWithClass) {
                        let rows = $(this).find('tbody').children();
                        let allRowsHidden = true;
                        rows.each(function (){
                            if($(this).css('display') !== 'none'){
                                allRowsHidden = false
                            }
                        })
                        if(allRowsHidden){
                            $(this).hide()
                        } else {
                            $(this).show();
                        }
                    } else {
                        $(this).hide();
                    }
                }
            })
        }

        // Category Click function....
        let categoryClicked = $('.subnav-content span')
        categoryClicked.click(function (event) {
            event.stopPropagation();
            let clickedItem = $(this).text()
            $(this).addClass('category-active').siblings().removeClass('category-active')
            $('div[data-gender]').each(function () {
                if ($(this).attr('data-gender') === subNavText) {
                    if (clickedItem === $(this).attr('data-id')) {
                        let rows = $(this).find('tbody').children();
                        let allRowsHidden = true;
                        rows.each(function (){
                            if($(this).css('display') !== 'none'){
                                allRowsHidden = false
                            }
                        })
                        if(allRowsHidden){
                            $(this).hide()
                        } else {
                            $(this).show();
                        }
                    } else {
                        $(this).hide()
                    }
                }
            })
            hideDivIfNoSizeValues()
        })

        hideDivIfNoSizeValues()

        // To display tables for separate genders on click
        $('.subnav').click(function () {
            let thisSubnavTxt = $(this).children('.subnavbtn').text().replace(/'/g, "").toLowerCase();
            $(this).addClass('sub-active').siblings().removeClass('sub-active')
            $('.subnav-content').empty();
            let typesArray = []
            $('div[data-gender]').each(function () {
                let containerGender = $(this).attr('data-gender')
                if (thisSubnavTxt === containerGender) {
                    console.log('Match found:', thisSubnavTxt, '===', containerGender);
                    let verifyBrand = $(this).parents('.container').attr('id');

                    if (selectedValuePro === verifyBrand) {
                        if ($(this).attr('data-gender') === thisSubnavTxt) {
                            let types = $(this).attr('data-id')
                            typesArray.push(types);
                        }
                    }
                    $(this).show();
                } else {
                    $(this).hide();
                }
            })
            let uniqArray = typesArray.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });

            uniqArray.forEach(uniqItem => {
                $('.subnav-content').append('<span href="">' + uniqItem + '</span>');
            });

            if ($(this).hasClass('sub-active')) {
                $(this).children('.subnav-content').children('span:first-of-type').addClass('category-active')
            }

            // To display Particular category tables only on load
            let activeElementWithClass = $('.category-active').text()
            $('div[data-gender]').each(function () {
                // console.log($(this).attr('id'))
                if ($(this).attr('data-gender') === thisSubnavTxt) {
                    if ($(this).attr('data-id') === activeElementWithClass) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                }
            })

            // Category Click function....
            let categoryClicked = $('.subnav-content span')
            categoryClicked.click(function (event) {
                event.stopPropagation();
                let clickedItem = $(this).text()
                $(this).addClass('category-active').siblings().removeClass('category-active')
                $('div[data-gender]').each(function () {
                    if ($(this).attr('data-gender') === thisSubnavTxt) {
                        if (clickedItem === $(this).attr('data-id')) {
                            $(this).show()
                        } else {
                            $(this).hide()
                        }
                    }
                })
                hideDivIfNoSizeValues()
            })

            hideDivIfNoSizeValues()
        })
    })

    // Hide the empty div.containers if no sizes are present
    function hideDivIfNoSizeValues(){
    let tableDivs = $("div:has(table[data-gender])")

    tableDivs.each(function () {
        let trs = $(this).find("table[data-gender] tbody tr:not(:first-child)")
        let allHaveDisplay = trs.toArray().every(tr => $(tr).css('display') === 'none');

        if(allHaveDisplay){
            $(this).hide()
        }
    })
    }
    hideDivIfNoSizeValues()

    // Making the Size row bold
    let sizeRow = document.querySelectorAll("table[data-gender] tbody tr td")
    sizeRow.forEach(sizeBox => {
        if(sizeBox.textContent === 'size' || sizeBox.textContent === 'sizes' || sizeBox.textContent === "Size"){
            let sizeBoxRow = sizeBox.parentElement;
            sizeBoxRow.style.fontWeight = '700'
        }
    })

// To append the block whose data gender matches with nav item ex: women's, mens
// $(document).ready(function () {
//     $('.subnav').each(function () {
//         let navGender = $(this).hasClass('sub-active');
//         let subnavText = $(this).children('.subnavbtn').text().replace(/'/g, "").toLowerCase();
//         console.log(subnavText, ' ][');
//         let subNavContent = $(this).children('.subnav-content');
//         console.log($('.container').attr('id'), ' sjdfgo')
//         if ($('#brand-select').val() === $('.container').attr('id')) {
//         }
//         $('table[data-gender]').each(function () {
//             let tableGender = $(this).attr('data-gender');
//             if (subnavText === tableGender) {
//                 subNavContent.append('<a href="">' + $(this).attr('data-type') + '</a>');
//             }
//             if (navGender) {
//                 // Add your logic for 'sub-active' class here if needed
//             }
//         });
//     });
// });


})
}
}